module.exports = __webpack_public_path__ + "img/problem-last-img.a456e8c1.png";